import { useContext } from 'react';
import LocalizationContext from '../contexts/LocalizationContext'; // Fix: Import 'CartContext' from the correct file path

export const useLocalization = () => useContext(LocalizationContext);